module.exports = __webpack_public_path__ + "media/images/pc/articles/report_temp_03-11ae212546f2d83382fa8032be738dc8.webp";